<script setup>
  import { ref } from "vue";
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Link, Head } from '@inertiajs/inertia-vue3';
  import BaseButton from "@/Components/BaseButton.vue";
  import BaseIcon from "@/Components/BaseIcon.vue";
  import { mdiPlusCircle, mdiFilePdfBox, mdiFileTableOutline, mdiInformationOutline } from "@mdi/js";
  import CardBox from "@/Components/CardBox.vue";
  import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
  import IconRounded from "@/Components/IconRounded.vue";

  const props = defineProps({
      //records: Array,
      template: String,
      title: String,
      fileName: String,
      levels: Object,
      collaborators: Object,
      //ciclos: Object,
      isAdmin: Boolean,
      isCoord: Boolean,
      plantilla: String

  });
  //let elementsDisabled = getElementsByTagName('input', 'select');
  const loading = ref(false)
  const resource = ref('reportasistencia')
  const errors = ref({})
  const error = ref('')
  const form = ref({
    'anio_consulta': '',
    'id_collaborator': -1,
    'start_date':'',
    'end_date': '',

  })
  const filters = ref([])
  const records = ref([])
  //const id_classroom = ref(0)
  //const ref_ciclo= ref(0)

  const getRecords = async () => {

    if (props.template == 'asistenciaxcolaborador') {
      if (!form.value.start_date || !form.value.end_date) { // <-- !form.value.ref_ciclo Para Periodo anual
          //this.$message.error('Seleccionar estudante');
          error.value = 'Debe seleccionar las fechas'
          return false;
      } else {
        error.value = '';
      }
    }
    
    loading.value = true;
    records.value = [];
    await axios.post(`/${resource.value}/records`, form.value)
        .then(response => {
            records.value = response.data;
        });
    loading.value = false;
    getTextSelect1() //<-- get texto de un select
    console.log(records.value)
  }

  const sortNombre = () => {
      form.value.is_sort_nombre = true;
      form.value.is_sort_puntaje= false;
      form.value.sort_nombre = !form.value.sort_nombre;
      getRecords();
  }

  const exportFile = async (format) => {
    loading.value = true;
    // this.loadingSubmit = true;
    errors.value = {};
    //console.log('cr_ugel '+form.value.id_classroom_ugel)
    //console.log('cr '+form.value.id_classroom)
    //console.log('ciclo '+form.value.ref_ciclo)
    await axios({
        url: `/${resource.value}/export`,
        method: 'POST',
        responseType: 'blob',
        data: {
          'records': records.value,
          'format': format,
          'template': props.template,
          'id_collaborator': form.value.id_collaborator ? form.value.id_collaborator : 0,
          //'id_classroom_ugel': form.value.id_classroom_ugel,
          'start_date': form.value.start_date,
          'end_date': form.value.end_date
        }
    }).then(response => {
      let res = response.data;
      if (res.type === 'application/json') {
          //this.$message.error('Error al exportar');
          console.log('Error al exportar')
      } else {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        //link.setAttribute('download', 'calificacioness_' + Date.now() + '.' + format);
        if (format == 'preview') {
          link.target = "_blank";
          link.setAttribute('view', props.fileName + '.html');
        } else {
          link.setAttribute('download', props.fileName + '_' + selectText1.value + '.' + format);
        }
        document.body.appendChild(link);
        link.click();
      }
    }).catch(error => {
        console.log(error);
        errors.value = error;
    }).then(() => {
        loading.value = false;
    });
    // this.loadingSubmit = false;
    //

  }

  const number2nota = (notaN) => {
    let nota = parseFloat(notaN).toFixed(2);
    let result = (nota < 10.50 ? 'C' : (nota >= 10.50 && nota < 13.50 ? 'B' : (nota >= 13.50 && nota < 17.50 ? 'A' : (nota >= 17.50 && nota <= 20 ? 'AD' : 'E'))))
    //console.log(nota)
    return result
  }

  const selectText1 = ref('')
  const getTextSelect1 = () => {
    
    if (form.value.id_collaborator > 0) {
      var values = props.collaborators.map(function(o) {return o.id}) // <-- Crear una nueva lista con map aplicando una función
      var index = values.indexOf(form.value.id_collaborator ? form.value.id_collaborator : 0)
      //var index = form.value.id_classroom ? form.value.id_classroom : form.value.id_classroom_ugel
      
      /* if (form.value.id_classroom_ugel) {
        //selectText1.value = props.collaborators[index].label + '-' + props.collaborators[index].ref_mc
      } else {
        selectText1.value = props.collaborators[index].label
      } */

      selectText1.value = props.collaborators[index].apellidos + ' ' + props.collaborators[index].nombres
      //console.log(index)
    } else {
      selectText1.value = 'Todos';
    }
    
    console.log(selectText1.value)
    
  }

  // validar pares
  //const lastDay = ref('')
</script>

<template>
    <Head title="Reporte de Asistencia" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="flex justify-between items-center">
                <div>
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                      {{ title }} <!-- In basebutton: @click="route('dashboard')"-->
                      <small class="text-red-600" v-if="error">{{ error }}</small>           
                    </h2> 
                </div>
                <!-- <div>
                    <Link :href="route(rutaPrefijo+'-create')">
                        <BaseButton
                            color="info"
                            :icon="mdiPlusCircle"
                            small
                            label=" Nuevo"
                            class="inline-flex"
                        />
                    </Link>
                </div> -->
            </div>
        </template>

        <div class="py-12">
            <!-- Loader -->
            <div v-if="loading" class="flex flex-col justify-center items-center md:h-[calc(100vh_-113px)] h-[calc(100vh-_114px)] absolute bottom-0 bg-white w-full z-50 bg-opacity-80">
                <!-- LRR Loader Pulso <div class="mb-10">
                    <div class="relative inline-flex">
                        <div class="w-8 h-8 bg-rose-600 rounded-full"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-ping"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-pulse"></div>
                    </div>
                </div> -->
                <div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-rose-600 mb-10" />
                <p class="text-rose-600">Espere por favor ...</p>
                <!-- LRR Button loader <div>
                    <button type="button"
                        class="inline-flex  items-center btn btn-rose text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg ">
                        <div class="border-rose-400 h-5 w-5 animate-spin rounded-full border-4 border-t-white mr-2" />
                        Cargando
                    </button>
                </div> -->
            </div>
            <div class="container mx-auto sm:px-6 lg:px-8 px-4"><!--max-w-7xl-->
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg" :class="loading ? 'pointer-events-none' : ''">
                    
                    <div class="p-6 bg-white border-b border-gray-200">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        <!-- <div>
                          <label for="list_periodo-choice">Escoge un periodo:</label>
                          <input type="search" placeholder="Periodo" list="list-periodos" id="list_periodo-choice" name="list_periodo-choice" style="width: 300px;">
                          <datalist
                              id="list-periodos"
                              name="list-periodos"
                              class="flat">
                              <option v-for="option in ciclos" :value="option.id">{{ option.label }}</option>
                          </datalist>
                        </div> -->
                        
                        <!-- Tiene filtro de fecha, no requiere este campo -->
                        <!-- <div class="mb-4 text-center">
                          <input name="year" class="w-16 ml-3 rounded-lg" type="text" v-model="form.anio_consulta"
                                :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR">
                        </div> -->
                        
                        <div class="mb-4">
                          <ul>
                            <li>El reporte se basa en pares de marcaciones, debe existir un ingreso y una salida para el cálculo de tardanza.</li>
                            <li>Se considera una inconsistencia si sólo marca una vez al día (ingreso o salida) o marca en feriado, sábado o domingo si no corresponde a su turno.</li>
                            <li v-if="template == 'asistencia_tardanzayfaltadescuento'"><b>En el caso de descuento</b> debe filtrar del primero al último mes para que los valores de descuento sean correctos</li>
                          </ul>
                        </div>

                        <div class="grid grid-cols-1 gap-3 md:grid-cols-4">

                          <div class="relative">
                            <label class="block font-bold mb-2 ml-2">Fecha Inicio</label>
                            <input type="date" v-model="form.start_date"
                              class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                          </div>

                          <div class="relative">
                            <label class="block font-bold mb-2 ml-2">Fecha Fin</label>
                            <input type="date" v-model="form.end_date"
                              class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                          </div>
                          
                          <!-- <div class="relative">
                            <label class="block font-bold mb-2 ml-2">Nivel</label>
                            <select v-model="form.ref_ciclo" @change="getRecords()"
                              class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                              <option value="" selected>Todos</option>
                              <option v-for="option in levels" :value="option.id">{{ option.label }}</option>
                            </select>
                          </div> -->

                          <div class="relative">
                            <label class="block font-bold mb-2 ml-2">Colaborador</label>
                            <select v-model="form.id_collaborator" @change="getRecords()"
                              class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                              <option value="-1" selected>Seleccionar Empleado</option>
                              <option value="0">Todos</option>
                              <option v-for="option in collaborators" :value="option.id">{{ option.apellidos + ' ' + option.nombres }}</option>
                            </select>
                          </div>

                          <!-- <div v-if="template=='calificationsugel'" class="relative">
                            <label class="block font-bold mb-2 ml-2">Aula UGEL</label>
                            <select v-model="form.id_classroom_ugel" @change="getRecords()"
                              class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                              <option value="0" selected>Seleccionar un aula</option>
                              <option v-for="option in classrooms" :value="option.id">{{ option.label + ' - ' + option.ref_mc }}</option>
                            </select>
                          </div> -->
                          
                        </div>
                        <!-- <div class="mt-4">
                          <div class="relative">
                            <label class="block font-bold mb-2 ml-1">Estudiante</label>
                            <select v-model="form.id_student" @change="getRecords()"
                              class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                              <option value="0" selected>Todos</option>
                              <option v-for="option in students" :value="option.id">{{ option.apellidos + ' ' + option.nombres }}</option>
                            </select>
                          </div>
                        </div> -->

                        <div class="mt-4"> <!-- v-if="records.length" -->
                          <!-- <div class="inline-block pr-2 ml-1" @click="exportFile('pdf')">
                            Exportar
                            <IconRounded color="" :icon="mdiFilePdfBox" title="Exportar a PDF" class="ml-1 text-red-800"
                             /> 
                          </div> -->
                          <div class="inline-block ml-4" v-if="$page.props.auth.user.id_rol == 1">
                              <!--  :href="'/reportasistencia/preview?id_collaborator='" -->
                             <BaseButton
                              :disabled="records.length <= 0"
                              @click="exportFile('preview')"
                              
                              color="info"
                              :icon="mdiFileTableOutline"
                              label="Vista debug txt"
                              small
                              target="_blank"
                              />
                          </div>
                          <div class="inline-block ml-4">
                              <!--  :href="'/reportasistencia/preview?id_collaborator='" -->
                             <BaseButton
                              :disabled="records.length <= 0 || loading"
                              :class="records.length <= 0 || loading || form.id_collaborator < 0 ? 'pointer-events-none' : ''"
                              :href="'/reportasistencia/export/preview?start_date='+form.start_date+'&end_date='+form.end_date+'&template='+template+'&id_collaborator='+form.id_collaborator"
                              color="info"
                              :icon="mdiFileTableOutline"
                              label="Vista previa"
                              small
                              target="_blank"
                              />
                          </div>
                          <!-- <div class="inline-block ml-4">
                             <BaseButton
                              :disabled="records.length <= 0 || loading"
                              @click="exportFile('pdf')"
                              color="danger"
                              :icon="mdiFileTableOutline"
                              label="Exportar"
                              small
                              target="_blank"
                              />
                          </div> -->
                          <div class="inline-block ml-4">
                             <BaseButton
                              :disabled="records.length <= 0 || loading"
                              @click="exportFile('xlsx')"
                              color="success"
                              :icon="mdiFileTableOutline"
                              label="Exportar"
                              small
                              target="_blank"
                              />
                          </div>
                          <!-- <div v-if="modulo=='payementOrder' && showDownloadTxt && countChecked" class="inline-block">
                            <IconRounded color="" :icon="mdiFileDocument" title="Exportar a txt" class="ml-1 text-blue-700"
                            @click="exportFile('txt')" />
                          </div> -->
                        </div>

                        
                        <CardBox v-if="records.length" class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <div class="w-full overflow-x-auto">
                              <table>
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <!-- <th @click="sortNombre">Nombre
                                      <i v-if="form.is_sort_nombre && form.sort_nombre" class="fas fa-sort-up"></i>
                                      <i v-else-if="form.is_sort_nombre" class="fas fa-sort-down"></i>
                                      <i v-else class="fas fa-sort"></i>
                                    </th>
                                    <th>Bimestre</th>
                                    <th>Curso</th> -->
                                    
                                    <th title="Colaborador">Colaborador</th>
                                    <th title="Fecha de registro">Fecha Registro</th>
                                    <th title="Promedio después del Simulacro">Estado</th>
                                    
                                </tr>
                                </thead>
                                <tbody :set="lastDay = ''">
                                <tr v-for="(row, index) in records" :key="row.id">
                                    <td data-label="#">
                                    {{ index + 1 }}
                                    </td>
                                    <td data-label="Nombre">
                                    {{ row.fullname }}
                                    </td>
                                    <td data-label="Fecha Registro">
                                      <!-- :class="(row.fecha_hora_dayrfc != lastDay ? lastDay = row.fecha_hora_dayrfc : (index >= 0 && (index % 2) > 0 ? 'text-red-600' : ''))" -->
                                     <span>{{ row.fecha_hora }}</span>
                                    </td>
                                    <td data-label="Estado">
                                      <small :class="(row.status == 1 ? 'text-green-600' : 'text-yellow-600')">
                                        {{ row.status == 1 ? 'Reloj' : 'Manual' }}
                                      </small>
                                    </td>

                                    <!--<td data-label="Progress" class="lg:w-32">
                                    <progress
                                        class="flex w-2/5 self-center lg:w-full"
                                        max="100"
                                        :value="row.progress"
                                    >
                                        {{ row.progress }}
                                    </progress>
                                    </td>
                                    -->
                                    <!-- <td data-label="R. Simulacro" class="lg:w-1 whitespace-nowrap">
                                      <small
                                        :class="(row.simulacro_admision < 1  ? 'text-red-600' : (row.simulacro_admision == 1  ? 'text-green-600' : ''))"
                                        :title="row.simulacro_admision"
                                        >{{ (row.simulacro_admision == 1 ? 'Aprobado' : (row.simulacro_admision == 2 ? 'Ausente' : 'Desaprobado'))  }}
                                      </small>
                                    </td>
                                    <td data-label="Promedio D.S">
                                      {{ row.promediods }}

                                    </td> -->
                                    
                                </tr>
                                </tbody>
                            </table>
                            </div>
                           
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>